{
  "brand": "OnBrand Mail",
  "brandTagline": "OnBrand Mail — signatures e-mail gérées de façon centralisée.",
  "language": "Langue",
  "sampleData": "Données d’exemple",
  "sampleDataHint": "VITE_MOCK_SESSION est activé — tout à l’écran est une donnée de test.",
  "toggleColorScheme": "Changer le thème",
  "switchToLight": "Passer en mode clair",
  "switchToDark": "Passer en mode sombre",
  "accountMenu": "Menu du compte",
  "signOut": "Se déconnecter",
  "signIn": "Se connecter",
  "retry": "Réessayer",
  "loading": "Chargement…",
  "save": "Enregistrer",
  "cancel": "Annuler",
  "delete": "Supprimer",
  "edit": "Modifier",
  "create": "Créer",
  "search": "Rechercher",
  "back": "Retour",
  "next": "Suivant",
  "close": "Fermer",
  "yes": "Oui",
  "no": "Non",
  "unknownError": "Erreur inconnue.",
  "apiUnreachableTitle": "Le portail n’a pas pu joindre l’API",
  "apiUnreachableHint": "En développement, l’API tourne sur le port 5138 et Vite la proxifie. Vérifiez qu’elle est démarrée.",
  "signInMicrosoftGoogle": "OnBrand Mail utilise votre compte professionnel Microsoft ou Google.",
  "signInGoogle": "OnBrand Mail utilise votre compte Google Workspace.",
  "signInMicrosoft": "OnBrand Mail utilise votre compte professionnel Microsoft.",
  "continueMicrosoft": "Continuer avec Microsoft",
  "continueGoogle": "Continuer avec Google",
  "noSignInTitle": "Connexion non configurée",
  "noSignInBody": "Ce déploiement n’a pas encore de fournisseur d’identité. Un administrateur doit en configurer un avant que quiconque puisse se connecter.",
  "accessNotGrantedTitle": "Accès pas encore accordé",
  "accessNotGrantedBody": "Vous êtes connecté en tant que {{email}}, mais aucun rôle n’a encore été attribué à ce compte. Un administrateur doit vous donner l’accès avant que quoi que ce soit soit visible.",
  "tryAgain": "Réessayer",
  "backToTenant": "Retour au locataire",
  "manage": "Gérer",
  "never": "Jamais",
  "unknown": "Inconnu",
  "copy": "Copier",
  "copied": "Copié",
  "refresh": "Actualiser",
  "continue": "Continuer",
  "confirm": "Confirmer",
  "remove": "Retirer",
  "add": "Ajouter",
  "open": "Ouvrir",
  "download": "Télécharger",
  "upload": "Téléverser",
  "settings": "Paramètres",
  "actions": "Actions",
  "status": "Statut",
  "name": "Nom",
  "email": "E-mail",
  "description": "Description",
  "enabled": "Activé",
  "disabled": "Désactivé",
  "active": "Actif",
  "inactive": "Inactif",
  "none": "Aucun",
  "all": "Tous",
  "optional": "Facultatif",
  "required": "Obligatoire",
  "any": "N’importe laquelle",
  "done": "Terminé",
  "reason": "Motif",
  "age": {
    "unknown": "à un moment inconnu",
    "justNow": "à l'instant",
    "minutesAgo": "il y a {{count}} minutes",
    "oneHourAgo": "il y a 1 heure",
    "hoursAgo": "il y a {{count}} heures",
    "oneDayAgo": "il y a 1 jour",
    "daysAgo": "il y a {{count}} jours"
  }
}
